import { GENERAL_STATE_KEY, GeneralState } from './general-reducer';

export enum GENERAL_ACTION_TYPE {
  SET_STATE = 'GENERAL/SET_STATE',
  INITIAL_LOAD = 'GENERAL/INITIAL_LOAD',
  GET_CONFIG = 'GET_CONFIG',
}

export type SetGeneralStateAction<KeyName extends keyof GeneralState> = {
  type: GENERAL_ACTION_TYPE.SET_STATE;
  payload: { key: KeyName, value: GeneralState[KeyName] };
};

export type InitialLoad = {
  type: GENERAL_ACTION_TYPE.INITIAL_LOAD;
};

export type GetConfig = {
  type: GENERAL_ACTION_TYPE.GET_CONFIG;
};

export type GeneralActions = SetGeneralStateAction<GENERAL_STATE_KEY> | InitialLoad | GetConfig;
